import 'babel-polyfill'
import Vue from 'vue'
import globalVue from './mixins/global'

import i18n from './i18n'
import { ValidationObserver, ValidationProvider } from 'vee-validate'

import { VPopover, VTooltip } from 'v-tooltip'

// validation setup
import './config/validation/vee-validate-config'

import FlashMessage from '@smartweb/vue-flash-message'

// import main layout component
import mainLayout from './components/common/main-layout/main-layout'

// directives
import autofocus from '@/directives/autofocus'

// cookies plugin
import vueCookies from 'vue-cookies'
import userService from '@/services/user'

// TODO check if can be used only in component
import VueBar from 'vuebar'

import VueDatePicker from '@mathieustan/vue-datepicker'

// Options: You can set lang by default
Vue.use(VueDatePicker, {
  lang: 'en'
})

Vue.use(VueBar)
userService.init()
// main styles
require('./assets/styles/main.scss')

Vue.config.productionTip = false

// install validation components
Vue.component('ValidationObserver', ValidationObserver)
Vue.component('ValidationProvider', ValidationProvider)

Vue.component('mainLayout', mainLayout)

// install tooltip
Vue.component('v-popover', VPopover)
Vue.component('v-tooltip', VTooltip)
Vue.use(FlashMessage)
Vue.directive('autofocus', autofocus)
Vue.use(vueCookies)

// require basic components
// importing this way because editor have trouble recognizing that components are already imported when using loop like below
require('./components/base/importBasicComps.js')

require('./config/axios')

Vue.mixin(globalVue)

// function loadPageComponents () {
//   Vue.component('page-create-account', () => import(/* webpackChunkName: "page-create-account" */ './pages/page-create-account'))
//   Vue.component('page-digital-services', () => import(/* webpackChunkName: "page-digital-services" */ './pages/page-digital-services'))
//   Vue.component('page-email-verification', () => import(/* webpackChunkName: "page-email-verification" */ './pages/page-email-verification'))
//   Vue.component('page-forgotten-password', () => import(/* webpackChunkName: "page-forgotten-password" */ './pages/page-forgotten-password'))
//   Vue.component('page-forgotten-password-confirmation', () => import(/* webpackChunkName: "page-forgotten-password-confirmation" */ './pages/page-forgotten-password-confirmation'))
//   Vue.component('page-payment-fail', () => import(/* webpackChunkName: "page-payment-fail" */ './pages/page-payment-fail'))
//   Vue.component('page-payment-success', () => import(/* webpackChunkName: "page-payment-success" */ './pages/page-payment-success'))
//   Vue.component('page-registration-email-sent', () => import(/* webpackChunkName: "page-registration-email-sent" */ './pages/page-registration-email-sent'))
//   Vue.component('page-registration-link-expired', () => import(/* webpackChunkName: "page-registration-link-expired" */ './pages/page-registration-link-expired'))
//   Vue.component('page-reset-password-confirmation', () => import(/* webpackChunkName: "page-reset-password-confirmation" */ './pages/page-reset-password-confirmation'))
//   Vue.component('page-reset-password-link-expired', () => import(/* webpackChunkName: "page-reset-password-link-expired" */ './pages/page-reset-password-link-expired'))
//   Vue.component('page-services-overview', () => import(/* webpackChunkName: "page-services-overview" */ './pages/page-services-overview'))
//   Vue.component('page-support', () => import(/* webpackChunkName: "page-support" */ './pages/page-support'))
//   Vue.component('page-user-account', () => import(/* webpackChunkName: "page-user-account" */ './pages/page-user-account'))
//   Vue.component('page-user-bills', () => import(/* webpackChunkName: "page-user-bills" */ './pages/page-user-bills'))
//   Vue.component('page-user-login', () => import(/* webpackChunkName: "page-user-login" */ './pages/page-user-login'))
//   Vue.component('page-user-registration', () => import(/* webpackChunkName: "page-user-registration" */ './pages/page-user-registration'))
//   Vue.component('page-user-reset-password', () => import(/* webpackChunkName: "page-user-reset-password" */ './pages/page-user-reset-password'))
//   Vue.component('page-verify-email-change', () => import(/* webpackChunkName: "page-verify-email-change" */ './pages/page-verify-email-change'))
//   Vue.component('page-verify-registration', () => import(/* webpackChunkName: "page-verify-registration" */ './pages/page-verify-registration'))
// }

if (document.getElementById('selfcare-vue')) {
  const requireComponent = require.context('./pages/', false, /page-[^\\]*\.vue$/)
  requireComponent.keys().forEach((fileName) => {
    const componentConfig = requireComponent(fileName)
    const componentName = fileName.replace(/^\.\/(.*)\.\w+$/, '$1') // TODO Normalize component names
    Vue.component(componentName, componentConfig.default || componentConfig)
  })

  // loadPageComponents()

  new Vue({
    i18n,
    el: '#selfcare-vue'
  }).$mount('#selfcare-vue')
}
